import { TMSEquipmentType } from 'types/Load';
import { useThrowableSWR } from 'utils/fetcher';

type ModesResponse = TMSEquipmentType[];

/**
 * Fetches the list of available rate modes from the TMS at `/load/options/modes`.
 * Currently powered by MercuryGate-Boomi on the BE (static defaults with future
 * MG code-table fallback); other TMSes return an empty list.
 */
export function useFetchModes(tmsID: number) {
  const { data, error, isLoading } = useThrowableSWR<ModesResponse>(
    tmsID ? `load/options/modes?tmsID=${tmsID}` : null,
    false // Don't retry on 404s
  );

  return {
    modes: data,
    isLoading,
    error,
  };
}
